// Cross-app deep links from the clinic panel. Legal pages live on the marketing
// site (doccareplus.com). Overridable via VITE_MARKETING_URL per environment.
export const MARKETING_URL = import.meta.env.VITE_MARKETING_URL ?? 'https://doccareplus.com';

// Placeholder support contact shown on the PendingPayment lock screen (see FE-4).
// TODO: replace with the real support address once confirmed; overridable via VITE_SUPPORT_EMAIL.
export const SUPPORT_EMAIL = import.meta.env.VITE_SUPPORT_EMAIL ?? 'support@doccareplus.com';
